// extracted by mini-css-extract-plugin
export default {"emptyStateContainer":"ActionTableV2__emptyStateContainer___W3aNw"};